import React from 'react';
import { BandMembersEpoch } from '../../Band.interface';
import { Link } from 'react-router-dom';
import './BandMembers.css';
import DTHeader from 'assets/img/DT-top-full.png';

const BandMembers = (props: { bandMembers: BandMembersEpoch, listed: boolean }) => {
  // console.log(props);
  const renderTop = 'Kapela Doktor Triceratops ' + props.bandMembers.from + (props.bandMembers.to ? '\u00A0-\u00A0' : '') + (props.bandMembers.to || '');
  const renderMembers = props.bandMembers.members.map(member => (
    <div className="band-member-card" key={member.link}>
      <Link to={'/kapela/' + member.link} >
        <span className="underline">
          {member.name}
        </span>
        <br />
        <span>
          {member.purpose}
        </span>
      </Link>
    </div>
  ));
  // const years = props.bandMembers.from + (props.bandMembers.to ? '-' : '') + (props.bandMembers.to || '');
  const epochId = props.bandMembers.id;
  const photoURL = props.bandMembers.photo || DTHeader;

  return (
    <div className="section">
      {props.listed
        ? null
        : <Link to={'/kapela'} className="band-link-back">&larr; Zpět na seznam</Link>
      }
      <div className="band-members">
        <p className="band-epoch">
          <Link to={'/kapela/rok-' + epochId}>
            {renderTop}
          </Link>
        </p>
        <Link to={'/kapela/rok-' + epochId}>
          <img src={photoURL} alt={renderTop} />
        </Link>
        <div className="band-members-cards">
          {renderMembers}
        </div>
      </div>
    </div>
  )
}

export default BandMembers;